// extracted by mini-css-extract-plugin
export default {"container":"service_container__2VaFb","home":"service_home__H71jy","searchbar":"service_searchbar__VrOdo"};